import { z } from 'zod'

/**
 * TanStack Router coerces `"true"`, `"false"` and numeric-looking strings into booleans and numbers
 * before validation runs, so any param holding free-form text or an ID must accept those back.
 */
export const looseString = z.union([z.string(), z.number(), z.boolean()]).transform(String)

/**
 * Accepts either a single value or repeated keys (`?tags=a&tags=b`) and normalizes to an array.
 * Repeated keys are the legacy format; new URLs serialize arrays as JSON.
 */
export function looseArray<T extends z.ZodType>(item: T) {
  return z
    .union([item, z.array(item)])
    .transform((value): z.output<T>[] => (Array.isArray(value) ? value : [value]))
}

/**
 * Accepts repeated keys or a comma-joined string and always emits comma-joined, so bookmarked URLs
 * written before the TanStack Router migration keep working.
 */
export const commaJoined = z
  .union([z.string(), z.array(z.string())])
  .transform((value) => (Array.isArray(value) ? value.join(',') : value))
